import Vue from 'vue'
import Vuex from 'vuex'

import deviceStore from '@/stores/device'
import chargeStore from '@/stores/charges'
import overlayStore from '@/stores/overlay'
import sessionStore from '@/stores/session'
import carsStore from '@/stores/cars'
import groupStore from '@/stores/group'
import appliancesStore from '@/stores/appliances'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    devicesStore: deviceStore,
    chargesStore: chargeStore,
    overlayStore: overlayStore,
    sessionStore: sessionStore,
    groupStore: groupStore,
    carsStore: carsStore,
    appliancesStore: appliancesStore
  },
  actions: {
    resetStates({ commit, dispatch }){
      dispatch('devicesStore/reset')
      dispatch('chargesStore/reset')
      // dispatch('overlayStore/reset')
      dispatch('sessionStore/reset')
      dispatch('carsStore/reset')
      dispatch('appliancesStore/reset')
      // reset state of verything here
    }
  }
})



// WEBPACK FOOTER //
// ./src/stores/index.js